import { render, staticRenderFns } from "./ProductServiceMicrositeTab.vue?vue&type=template&id=d7a84230&scoped=true"
import script from "./ProductServiceMicrositeTab.vue?vue&type=script&lang=js"
export * from "./ProductServiceMicrositeTab.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceMicrositeTab.vue?vue&type=style&index=0&id=d7a84230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a84230",
  null
  
)

export default component.exports